import { App } from './App';
import { api } from '../Api';

const Top: () => JSX.Element = () => {
  const dependencies = { api: api, doc: document };
  return App(dependencies);
};
export default Top;
